"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_SOCIALS = exports.ALL_SUPPORTED_DOMAINS = exports.STANDARD_SOCIAL_DOMAINS = void 0;
/**
 * Standard Social Domains refer to those that do not require special parsing
 * These urls are typically formatted as https://www.socialMediaSiteDomain.com/username
 */
const STANDARD_SOCIAL_DOMAINS = {
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    TWITTER: 'twitter',
    SOUNDCLOUD: 'soundcloud',
};
exports.STANDARD_SOCIAL_DOMAINS = STANDARD_SOCIAL_DOMAINS;
const ALL_SUPPORTED_DOMAINS = Object.assign(Object.assign({}, STANDARD_SOCIAL_DOMAINS), { YOUTUBE: 'youtube', O_SPOTIFY: 'open.spotify', P_SPOTIFY: 'play.spotify' });
exports.ALL_SUPPORTED_DOMAINS = ALL_SUPPORTED_DOMAINS;
const ALL_SOCIALS = Object.assign(Object.assign({}, STANDARD_SOCIAL_DOMAINS), { YOUTUBE: 'youtube', SPOTIFY: 'spotify' });
exports.ALL_SOCIALS = ALL_SOCIALS;
Object.freeze(STANDARD_SOCIAL_DOMAINS);
Object.freeze(ALL_SUPPORTED_DOMAINS);
Object.freeze(ALL_SOCIALS);
//# sourceMappingURL=enums.js.map